const redFlags = {
  slug: 'red-flags',
  title: 'Scam red flags on phone calls',
  description:
    'Warning signs that a call or text may be a scam: urgency, secrecy, threats, and requests for money or codes.',
  category: 'scams',
  guideType: 'tips',
  readMinutes: 4,
  partnerTip: 'none',
  relatedSlugs: ['what-not-to-do', 'verify-before-you-trust', 'common-phone-scams'],
  sections: [
    {
      type: 'paragraph',
      text: 'Scammers train themselves to sound professional. The content of the call matters more than the accent or the background noise. These red flags appear across countries and scam types.',
    },
    {
      type: 'heading',
      level: 2,
      text: 'Urgency and fear',
    },
    {
      type: 'list',
      items: [
        '“Act in the next hour or your account will be closed”',
        'Threats of arrest, deportation, or cutting off services',
        'Claims that only this caller can fix the problem',
      ],
    },
    {
      type: 'heading',
      level: 2,
      text: 'Secrecy',
    },
    {
      type: 'paragraph',
      text: 'They tell you not to tell family, your bank branch, or the police — because verification would expose the scam.',
    },
    {
      type: 'heading',
      level: 2,
      text: 'Unusual payment methods',
    },
    {
      type: 'list',
      items: [
        'Gift cards, wire transfers, cryptocurrency, or cash by courier',
        'Payment to a personal account instead of a business',
        'Fees to release a prize or inheritance',
      ],
    },
    {
      type: 'heading',
      level: 2,
      text: 'Requests for codes or access',
    },
    {
      type: 'paragraph',
      text: 'Banks and legitimate services never ask you to read out a one-time SMS code. Anyone who asks for that is trying to log in as you.',
    },
    {
      type: 'warning',
      text: 'Community reports on WhoDatNumber are helpful signals but not proof — always verify through official channels.',
    },
    {
      type: 'lookupCta',
    },
  ],
};

export default redFlags;

